module.exports = __webpack_public_path__ + "static/img/5.9ec7fbd.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/XVC/images/5.png
// module id = sLiw
// module chunks = 4